import store from './store/index';

export default(to, from, next) => {
  if(!store.getters.user){
    const routerIntentUrl = {
      toUrl: to.path,
      fromUrl: from.path 
    };
    store.dispatch('registerUnauthNavAttempt',routerIntentUrl);
    next({ path: '/login'});
  }
  else{
    const user = store.getters.user;
    const {perfil} = user;
    const routeName = to.name;
    const isAdminRoute = adminRoutes.includes(routeName);
    
    if ( perfil == "Administrador" || !isAdminRoute )  
      next();
    else
      next("/venta");
    
  }
};

const adminRoutes = [
  "usuarios",
  "servicios",
  "categorias",
  "productos",
  "reportes",
  "config"
];